import React from "react";
import { taskSolutionVersion } from "./solution-version.mjs";

export function taskLaunchNumberLabel(task) {
  const number = task?.launchNumber;
  return Number.isSafeInteger(number) && number > 0 ? `№${number}` : null;
}

// The database assigns this number once. List position, filters, cached
// results and the number of internal executions never change it.
export function TaskLaunchNumber({ task, compact = false }) {
  const label = taskLaunchNumberLabel(task);
  const version = taskSolutionVersion(task);
  const content = label
    ? <>Запуск <strong>{label}</strong></>
    : "Номер запуска недоступен";
  return compact
    ? <small className="task-launch-number compact"><span>{content}</span>{version && <span>Версия решения <strong>{version}</strong></span>}</small>
    : <div className="task-launch-number"><span>{content}</span>{version && <span>Версия решения <strong>{version}</strong></span>}</div>;
}
